import { render, staticRenderFns } from "./zuiminmenu.vue?vue&type=template&id=1b7223ec&scoped=true&"
import script from "./zuiminmenu.vue?vue&type=script&lang=js&"
export * from "./zuiminmenu.vue?vue&type=script&lang=js&"
import style0 from "./zuiminmenu.vue?vue&type=style&index=0&id=1b7223ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7223ec",
  null
  
)

export default component.exports